import type { Filters } from 'constants/filters';

import type { TAvailableRoutes, TFilterState } from './state';

export enum ActionTypes {
    ADD_FILTER,
    REMOVE_FILTER,
    UPDATE_FILTERS,
}

export type TReducerAction = {
    type: ActionTypes;
    payload: {
        route: TAvailableRoutes;
        filter?: Filters;
        values?: Array<string | number>;
        filters?: Record<Filters, TFilterState>;
    };
};

/**
 * A context action applying selected filter to current page/route.
 *
 * E.g.: Apply `CITIES` filter for `RECOMMENDED` page.
 *
 * @param route - Route to apply the filter to.
 * @param filter - Filter type to be applied.
 * @param values - Filtered values to be applied.
 */
export const addFilterAction = (
    route: TAvailableRoutes,
    filter: Filters,
    values: Array<string | number>
): TReducerAction => ({
    type: ActionTypes.ADD_FILTER,
    payload: {
        route,
        filter,
        values,
    },
});

/**
 * A context action removing selected filter from current page/route.
 *
 * E.g.: Remove `CITIES` filter from `RECOMMENDED` page.
 *
 * @param route - Route to remove the filter from.
 * @param filter - Filter type to be removed.
 */
export const removeFilterAction = (
    route: TAvailableRoutes,
    filter: Filters
): TReducerAction => ({
    type: ActionTypes.REMOVE_FILTER,
    payload: {
        route,
        filter,
    },
});

/**
 * A context action updating filters with current applied filters.
 *
 * @param route - Route to remove the filter from.
 * @param filters - Active filters to be applied
 */
export const updateFiltersAction = (
    route: TAvailableRoutes,
    filters: Record<Filters, TFilterState>
): TReducerAction => ({
    type: ActionTypes.UPDATE_FILTERS,
    payload: {
        route,
        filters,
    },
});
